var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.614,
    height: 48.745,
    viewBox: "0 0 43.614 48.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "css",
    transform: "translate(-7 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M50.614,5H7l3.848,43.614,17.959,5.131,17.959-5.131L50.614,5Z",
    fill: "#0277bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M24,8V48.92l14.367-4.1L41.574,8Z",
    transform: "translate(4.807 0.848)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M35.673,13H24v5.131h6.286L29.9,23.262H24v5.131h5.644l-.385,5.772L24,35.961v5.388l10.134-3.335.9-14.752h0Z",
    transform: "translate(4.807 2.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M26.6,13v5.131H15.185L14.8,13ZM20.7,23.262l.257,5.131H26.6V23.262Zm.513,7.7H16.083l.385,7.055L26.6,41.349V35.961l-5.259-1.8Z",
    transform: "translate(2.206 2.262)",
    fill: "#eee"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.1a0090ba231c6c275957e38da509f95a.svg";
export { ForwardRef as ReactComponent };